export const stripHTMLTagsFromString = (str: string): string =>
  str.replaceAll(/<[^>]*>/g, '')
